import { Image, LineClamp } from "@newsela/angelou";
import { useRouter } from "next/router";

import TopicMetaRow from "@/challenges/TopicMetaRow";
import { type ChallengeTopic } from "@/challenges/utils/interfaces";
import {
  cardHeaderBackgroundCss,
  challengeDetailCardContentCss,
  challengeDetailCardCss,
  challengeDetailCardTitle,
  descriptionChallengeTextCss,
  DetailsTextCss,
  divider,
  topicRowCss,
} from "./ChallengesTeacherTopicCard.style";

interface ChallengesTeacherTopicCardProps {
  topic: ChallengeTopic;
}

const ChallengesTeacherTopicCard = ({
  topic,
}: ChallengesTeacherTopicCardProps) => {
  const descriptionChallengeText = topic.description;
  const router = useRouter();

  const topicMetaRockMock = [
    {
      total: topic.total_articles,
      label: "articles",
    },
    {
      total: topic.total_interactions,
      label: "activities",
    },
    {
      total: topic.tokens,
      label: "tokens",
      icon: "/images/icons/challenge-monthly-icon.svg",
    },
  ];

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    event.key === "Enter" && router.push(`/challenges/${topic.topic_id}`);
  };

  return (
    <div
      css={challengeDetailCardCss}
      onClick={() => router.push(`/challenges/${topic.topic_id}`)}
      data-qa-selector={`IRC: Redirect to Topic Page with topic id ${topic.topic_id}`}
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div css={challengeDetailCardContentCss}>
        <div css={DetailsTextCss}>
          <h4 css={challengeDetailCardTitle}>{topic.title}</h4>
          <LineClamp
            css={descriptionChallengeTextCss}
            lines={3}
            text={descriptionChallengeText}
            innerElement="p"
          />
        </div>
        <Image src={topic.image.url} __css={cardHeaderBackgroundCss} alt="" />
      </div>
      <div css={divider} />
      <div css={topicRowCss}>
        <TopicMetaRow topics={topicMetaRockMock} small />
      </div>
    </div>
  );
};

export default ChallengesTeacherTopicCard;
